/** Join truthy class names. Tiny local alternative to `clsx`. */
export function cn(
  ...classes: Array<string | false | null | undefined>
): string {
  return classes.filter(Boolean).join(" ");
}

/** Turn a display string into a URL-safe slug. */
export function slugify(input: string): string {
  return input
    .toLowerCase()
    .replace(/['’.]/g, "")
    .replace(/&/g, " and ")
    .replace(/\//g, " ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/**
 * Ensure every slug in a list is unique by suffixing duplicates
 * with -2, -3, … (keeps human-readable URLs stable & collision-free).
 */
export function uniqueSlugs<T>(
  items: T[],
  getBase: (item: T) => string,
): string[] {
  const seen = new Map<string, number>();
  return items.map((item) => {
    const base = getBase(item);
    const count = seen.get(base) ?? 0;
    seen.set(base, count + 1);
    return count === 0 ? base : `${base}-${count + 1}`;
  });
}
